<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            EMS查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="freight" clearable label="运单号:" placeholder="请输入运单号"/>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div v-if="listShow">
            <van-steps direction="vertical" :active="0">
                <van-step v-for="(item, index) in dataList" :key="index">
                    <h3 v-if="item.acceptAddress.trimLeft().trimRight().length > 0">
                        【{{item.acceptAddress}}】{{item.remark}}</h3>
                    <h3 v-else>{{item.acceptAddress}}{{item.remark}}</h3>
                    <p>{{item.acceptTime}}</p>
                </van-step>
            </van-steps>
        </div>

    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button, Step, Steps} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {mailApiMap} from "@/api/mail";
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "EMSQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [Step.name]: Step,
            [Steps.name]: Steps,
        },
        data() {
            return {
                show: false,
                freight : '', // 运单号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                listShow: false, // 显示查询结果
                dataList: [], // 结果数据
            }
        },
        mounted(){
          this.logger.visit('107','0')
        },
        methods: {
            onConfirm(value) {
                this.value = value;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

          submit() {
            if (!this.freight) {
              Toast('请输入运单号')
            } else {
              this.show=true
            }
          },

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              this.listShow = false
              const res = await this.$httpUtils.getCommonUtils(`${mailApiMap.getMail}/${this.freight}`, data)
              this.show = false
              Toast.clear()
              if (res.data.succ) {
                const data = res.data.data.traces
                if (data.length > 0) {
                  this.listShow = true
                  this.dataList = Object.assign([], data.reverse())
                } else {
                  Toast.fail('请输入正确运单号')
                }

              } else {
                if (res.data.code === 171007) {
                  Toast.fail('请输入正确的验证码')
                  return
                }
                Toast.fail(res.data.msg)
              }
              this.logger.visit('107','1')
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if (!this.freight) {
                    Toast('请输入运单号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        this.listShow = false
                        const res = await this.$httpUtils.getCommonUtils(`${mailApiMap.getMail}/${this.freight}`, data)
                        Toast.clear()
                        // 刷新清空验证码
                        this.$refs.childFunction.interactionVerificationCode()
                        if (res.data.succ) {
                            const data = res.data.data.traces
                            if (data.length > 0) {
                                this.listShow = true
                                this.dataList = Object.assign([], data.reverse())
                            } else {
                                Toast.fail('请输入正确运单号')
                            }

                        } else {
                            if (res.data.code === 171007) {
                                Toast.fail('请输入正确的验证码')
                                return
                            }
                            Toast.fail(res.data.msg)
                        }
                        this.logger.visit('107','1')
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
<style>
    .query .van-field__label{
        width: 1.95rem;
    }
</style>

